import { Component, OnInit } from '@angular/core';
import {Router,ActivatedRoute} from "@angular/router";
import { HttpService } from '../core/services/http.service';
import { DomSanitizer,SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-start-tour',
  templateUrl: './start-tour.component.html',
  styleUrls: ['./start-tour.component.scss']
})
export class StartTourComponent implements OnInit {


  policyPath:any= null
  acceptedPrivacyPolicy = false;

  constructor(public router: Router, private httpService:HttpService,private sanitizer: DomSanitizer) {

   }

  public myInnerHeight: any;

  ngOnInit() {
    this.myInnerHeight = window.innerHeight;
    this.getPpolicy()
  }

  goToWelcomeScreenP(){
    if (!this.acceptedPrivacyPolicy) {
      alert("You must accept the Privacy Policy to continue.");
    } else {
      this.router.navigate(['welcome']);
    }
  }

  goBack(){
    this.httpService.logout();
  }

  getPpolicy() {
    this.httpService
      .callApi("getpolicyPath",{})
      .subscribe((response) => {
        if(response != null && response.path){
          this.policyPath = this.sanitizer.bypassSecurityTrustResourceUrl(response.path);
        }
       console.log(response)
      });
  }

  onResize(event){
    this.myInnerHeight = event.target.innerHeight;
  }
  goToWelcomeScreen(){
    this.router.navigate(['welcome']);
  }

}
